var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFoghorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2185,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 779,
    y: 767,
    width: 2185,
    height: 2079
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2567.04 1711.95 2963.93 1857.56 2715.42 2534.94 2318.52 2389.34Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2567.04 1711.95 2963.93 1857.56 2715.42 2534.94 2318.52 2389.34Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2080.94 1289.59 3143.66 1679.47 2743.53 2770.11 1680.81 2380.23Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-779 -767)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 779,
    y: 767,
    width: 2079,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188 1806.5C1188 1458.28 1470.28 1176 1818.5 1176 2166.72 1176 2449 1458.28 2449 1806.5 2449 2154.72 2166.72 2437 1818.5 2437 1470.28 2437 1188 2154.72 1188 1806.5Z",
    fill: "#4472C4",
    fillRule: "evenodd",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033,
    y: 1021,
    width: 1571,
    height: 1571,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M866.67 259.411 820.683 305.398C966.897 451.612 966.897 689.799 820.683 836.012L866.67 881.999C1038.82 711.023 1038.82 431.566 866.67 259.411Z",
    stroke: "#000000",
    strokeWidth: 11.7914,
    transform: "matrix(0.938814 0.344424 -0.353475 0.963485 2080.94 1289.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.518 351.385 727.531 397.371C823.042 492.882 823.042 647.349 727.531 744.039L773.518 790.026C894.969 668.574 894.969 472.836 773.518 351.385Z",
    stroke: "#000000",
    strokeWidth: 11.7914,
    transform: "matrix(0.938814 0.344424 -0.353475 0.963485 2080.94 1289.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.724 445.716 636.737 491.703C681.544 536.51 681.544 608.438 636.737 653.245L682.724 699.232C753.472 628.483 753.472 515.285 682.724 445.716Z",
    stroke: "#000000",
    strokeWidth: 11.7914,
    transform: "matrix(0.938814 0.344424 -0.353475 0.963485 2080.94 1289.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.27 407.983 41.27 723.994 270.024 723.994 565.989 966.897 565.989 165.08 270.024 407.983Z",
    stroke: "#000000",
    strokeWidth: 11.7914,
    transform: "matrix(0.938814 0.344424 -0.353475 0.963485 2080.94 1289.59)"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoghorn);
export default __webpack_public_path__ + "static/media/Foghorn.9d05383eaf0d0e20ad11957963b27d22.svg";
export { ForwardRef as ReactComponent };